import React from 'react';
import PropTypes from 'prop-types';
import { withNamespaces } from 'react-i18next';

const CancelButton = ({t, text, type, loading, onClick}) => (
    <button type={type}
            className="btn btn-default"
            onClick={onClick}
            disabled={loading}
    >
        {t(text)}
    </button>
);

CancelButton.propTypes = {
    text: PropTypes.string,
    type: PropTypes.oneOf(['button', 'submit']),
    loading: PropTypes.bool,
    onClick: PropTypes.func,
};

CancelButton.defaultProps = {
    type: 'button',
    text: 'COMMON.CANCEL',
};

export default withNamespaces()(CancelButton);


// WEBPACK FOOTER //
// ./src/components/form/cancel-button.js